import { render } from "./ResultDetail.vue?vue&type=template&id=7fb3a58e&scoped=true"
import script from "./ResultDetail.vue?vue&type=script&lang=js"
export * from "./ResultDetail.vue?vue&type=script&lang=js"

import "./ResultDetail.vue?vue&type=style&index=0&id=7fb3a58e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\LG\\Documents\\repositories\\opac\\search\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb3a58e"]])

export default __exports__